const Form054TC = {
    stepName: {
        Statement: "重要事項",
        SelectForm: "選擇「治療師現金津貼」",
        SchoolInfo: "基本資料",
        SelectPart: "選擇甲部／乙部",
        SectionA: "甲部",
        SectionB: "乙部",
        Certification: "聲明",
        Confirmation: "確認",
    },
    label: {
        applyFormOption: {
            CGOT: "資助特殊學校「職業治療師現金津貼」",
            CGPT: "資助特殊學校「物理治療師現金津貼」",
            CGST: "資助特殊學校「言語治療師現金津貼」",
        },
        applyPartOption: {
            PartA: "甲部 以一／兩個{{fullName}}的空缺職位換取「津貼」",
            PartB: "乙部 以「津貼」代替{{fullName}}放取不少於30天核准假期的臨時補缺人員安排",
        },
        NROption: {
            N: "新申領津貼的職位",
            R: "修訂的申領",
        },
        changePreClaimOption: {
            unDelete: "不更改先前聲明",
            delete: "刪除先前聲明",
            change: "更改先前聲明",
        },
        OTRankOption: {
            SOT: "高級職業治療師",
            OTI: "一級職業治療師",
        },
        OTRankOptionPartB: {
            SOT: "高級職業治療師",
            OTI: "一級職業治療師",
            OTII: "二級職業治療師",
        },
        PTRankOption: {
            SPT: "高級物理治療師",
            PTI: "一級物理治療師",
        },
        PTRankOptionPartB: {
            SPT: "高級物理治療師",
            PTI: "一級物理治療師",
            PTII: "二級物理治療師",
        },
        salaryList: {
            pt34: "74515",
            pt25: "51095",
            pt19: "38595",
            pt26: "53500",
        },

        shortName: {
            CGOT: "職業治療師",
            CGPT: "物理治療師",
            CGST: "言語治療師",
        },
        rankOption: {
            CGOT: "和職級",
            CGPT: "和職級",
            CGST: "職級",
        },

        termsConditions: "我已閱讀、理解並同意上述條款和條件。",
        statementTwo: "本人理解申請人和教師需要擁有「智方便+」帳戶才能處理申請。",
        statement: "個人資料收集聲明",
        applyTitle: "請選擇：",
        noteTitle: "註",
        previousDate: "前次申領表格日期：",
        headerTitleOne: "基本資料",
        headerTitleTwo: "以一／兩個{{postName}}的空缺職位換取「津貼」",
        head1: "致 ：",
        head2: "教育局經常津貼組",
        head3: "[經辦人：一級會計主任 (經常津貼 )]",
        schoolName: "學校名稱",
        schoolCode: "學校代碼",
        Month: "月份",
        Year: "年份",
        SSDO: "高級學校發展主任",

        vacantPostNum: "申領現金津貼的凍結空缺職位數目",
        NR: "新申領津貼的職位／修訂",
        changePreclaim: "不更改先前聲明／刪除先前聲明／更改先前聲明：",
        preclaimNum: "請註明前次申領的申請編號",
        applicationNum: "申請編號",
        postRank: "申領現金津貼的凍結空缺職位所屬職級",
        startDate: "可撤回的職位空缺凍結期由",
        endDate: "可撤回的職位空缺凍結期至",
        leaveStartTime: "休假時期由",
        leaveEndTime: "休假時期至",
        qualifiedStartTime: "合資格時期由",
        qualifiedEndTime: "合資格時期至",
        qualifiedMonth: "（a）合資格月數",
        monthlySalary: "（b）月薪",
        MPFSubsidy: "（c）強積金供款津貼",
        Amount: "「津貼」金額",
        amountTip:
            "「津貼」金額 = （申領現金津貼的凍結空缺職位數目 x 合資格月數（每月） x 月薪（每月） + 上限強積金供款津貼 （每月））之和;",
        previousFormFile: "前次申領表格副本：",
        headerTitleThree:
            "以「津貼」代替{{postName}}放取不少於30天核準假期的臨時補缺人員安排",
        // temporaryOne: "休假{{postName}}的資料",
        temporaryStaffFormTitleOne: "休假{{postName}}的資料",
        temporaryStaffFormTitleTwo: "「津貼」的資料",
        staffName: "姓名",
        SRN: "職員參考編號",
        Rank: "職級",
        MPFFile: "強積金供款證明資料：",
        absenceReason: "缺勤原因",
        total: "總計",

        signName: "校監／校長姓名",
        signDate: "日期",
        signContactPerson: "聯絡人",
        signTelNo: "電話號碼",
        signSsdo: "高級學校發展主任",

        postNum: "職位數量",
    },
    labelStep: [
        { step: "(i)" },
        { step: "(ii)" },
        { step: "(iii)" },
        { step: "(iv)" },
    ],
    noteList: {
        STnoteOne:
            "編制數目4名以下的學校，只可把一個言語治療師空缺職位凍結，換取現金津貼，而編制數目4名或以上的學校，最多可把兩個言語治療師空缺職位凍結，換取現金津貼；",
        noteOne: "最多可把兩個{{postName}}空缺職位凍結，換取現金津貼；",
        noteTwo:
            "計算由起始日直至完結日（首尾兩天包括在內）的合資格申領「津貼」月數，包含以下三個元素：",
        noteTwoA: [
            {
                text: "合資格日數在起始月份的曆日總數中所佔的比例（如適用）；",
            },
            {
                text: "完整的曆月數（如適用）；以及",
            },
            {
                text: "合資格日數在完結月份曆日總數中所佔的比例（如適用）。",
            },
        ],
        noteTwoDetail:
            "合資格日數在起始月份的曆日總數中所佔的比例（如適用）；" +
            "\n\n" +
            "完整的曆月數（如適用）；以及",
        ExampleOne:
            "假設合資格申領「津貼」的時期是由二月五日至五月二十六日，計算合資格月數的方法如下：",
        noteTwoB: [
            {
                text: "起始月份的合資格日數為24日（二月五日至二月二十八日）除以28日（二月份的曆日總數）=0.857個月；",
            },
            {
                text: "由三月至四月有兩個完整的曆月數；",
            },
            {
                text: "完結月份的合資格日數為26日（五月一日至二十六日）除以31日（五月份的曆日總數）=0.839個月；以及",
            },
            {
                text: "合資格申領月數應為上述三個元素的總和（計算至三個小數位），即0.857+2+0.839=3.696。",
            },
        ],
        STnoteThree:
            "填寫言語治療師的中點薪金（由二零一三／一四學年起，為總薪級表第26點）。",
        noteThreeA:
            "填寫一級{{postName}}／高級{{postName}}的起薪點(如適用)。一級{{postName}}及高級{{postName}}的起薪點則分別為總薪級表第25點及34點。",
        noteThreeB:
            "填寫二級{{postName}}職位的中點薪金或一級{{postName}}／高級{{postName}}的起薪點(如適用)。由二零一三／一四學年起，二級{{postName}}的中點薪金為總薪級表第19點，而一級{{postName}}及高級{{postName}}的起薪點則分別為總薪級表第25點及34點。",
        noteFour:
            "如合資格申領期達60天或以上，強積金計劃僱主供款（月薪的5%，並以現行強積金規例所訂的最高金額為上限）將會包括在內。如換取現金津貼的{{postName}}空缺凍結期或{{postName}}放取核準假期的臨時補缺期少於60個曆日，而須向強積金供款，請提供證明資料。",
        noteFive: "填寫休假的{{postName}}的職員參考編號{{rank}}。",
        noteSix: "請注意，學校必須按照教育局通告第1／2006號規定批假。",
    },
    certifyList: {
        cNote: "本人證實 –",
        cTwo: "本校已獲校董會／法團校董會及大多數{{postName}}同意，在本學年上述期間凍結甲部所載的{{postName}}職位；",
        cThree: "(<i>就晉升職級 (即一級{{postName}}／高級{{postName}}</i>)的可撤回凍結空缺或臨時補缺人員安排)，學校已證明有實際需要把晉升職級的可撤回凍結空缺／臨時補缺人員安排轉為現金津貼；",
        cFour: "凍結甲部所載的{{postName}}職位並申領「津貼」，是因為該(等)核准編制的職位在上述期間有空缺及此項申領符合「津貼」所列明的申領條件；",
        cFive: "本校沒有就上述凍結期／休假 ，向政府提出其他津貼的申請；以及",
        cSix: "本校會把任何多收取的津貼退還教育局。",
    },

    errorMsg: {
        "E-0008": "輸入的內容格式錯誤",
        leaveDateRuls: "休假期限不少於30天",
        freezDateRuls: "空缺凍結期（不少於30天）",
        freezVacancy: "可撤回的職位空缺凍結期必須為最少30曆日",
        leavePeriod: "休假時期必須為最少30曆日",
        qualifiedPeriod: "合資格時期必須為最少30曆日",
        limitsEndDateRuls: "上述日期最遲為該學年的8月31日",
        postNumLimit: "空缺職位數目之和不能大於2",
        withinLimit: "合資格時期應該在休假時期範圍内",
        // qualifiedDateRules:
        //     "合資格時期（不少於30天），且截止日期不得晚於8月31日",
    },
};
export default Form054TC;
